/* eslint-disable no-new-func */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import data from './data';
export default {
  mixins: [data],
  methods: {
    headAddOper: function headAddOper(operMark) {
      // url = this.template(url, { row: row, user: this.$store.getters.sessionUser, req: this.$route.query })
      var oper = this.getHeadOperByMark(operMark);
      if (oper.url) {
        var url = this.template(oper.url, { user: this.$store.getters.sessionUser, req: this.$route.query });
        this.windowOpen(url, oper);
      } else {
        alert('未配置新增地址');
      }
    },
    headDeleteOper: function headDeleteOper(operMark) {
      var _this = this;

      if (this.batch_select.length < 1) {
        this.$Modal.warning({
          title: '删除提示',
          content: '未选择删除数据'
        });
        return;
      }
      this.$Modal.confirm({
        title: '删除提示',
        content: '数据删除后不可恢复，是否确定删除?',
        loading: true,
        okText: '确定删除',
        onOk: function onOk() {
          _this.batchDelete();
        }
      });
    },
    headRefreshOper: function headRefreshOper(pageNum) {
      this.query_grid_data(pageNum);
    },
    headExportOper: function headExportOper() {
      this.gridExportOptStatus = true;
      this.gridExportDataRequestParams = this.getGridRequestParams();
    },

    // 导出数据下载
    headDataExport: function headDataExport() {

      this.getParams();
    },
    getParams: function getParams() {
      var _this2 = this;

      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/funcGrid', params: { mark: 'bsp:model:exporttask' } }).then(function (resp) {
        if (resp.success) {
          console.log(resp.queryFields);
          var obj = {};
          if (resp.queryFields && resp.queryFields.length > 0) {
            resp.queryFields.forEach(function (item) {
              if (item.name != 'MODELID') {
                obj[item.defaultValue.replace('{{:=req.', '').replace('}}', '')] = item.defaultValue;
              }
            });
          }
          //  this.gridDataRequestParams ={}
          _this2.gridDataRequestParams = Object.assign(obj, _this2.getGridRequestParams());
          console.log(obj, _this2.gridDataRequestParams, 'getParams');
        } else {
          _this2.gridDataRequestParams = _this2.getGridRequestParams();
        }
        _this2.gridExportDataStatus = true;
      });
    },
    closeDataOptModal: function closeDataOptModal() {
      this.gridExportDataStatus = false;
    },
    headDealFunction: function headDealFunction(operMark) {
      // 头部操作
      var oper = this.getHeadOperByMark(operMark);
      if (oper.dealFunction) {
        var dealFunc = 'return ' + oper.dealFunction;
        var func = new Function(dealFunc)();
        func(this.batch_select, this);
      } else {
        alert('未配置自定义函数');
      }
    },
    rowAddOper: function rowAddOper(row, index, operMark) {
      var oper = this.getRowOperByMark(operMark);
      if (oper.url) {
        var url = this.template(oper.url, { row: row, user: this.$store.getters.sessionUser, req: this.$route.query });
        this.windowOpen(url, oper);
        this.modalStatus = true;
      } else {
        alert('未配置修改地址');
      }
    },
    rowDeleteOper: function rowDeleteOper(row, index, operMark) {
      var _this3 = this;

      this.$Modal.confirm({
        title: '删除提示',
        content: '数据删除后不可恢复，是否确定删除?',
        loading: true,
        okText: '确定删除',
        onOk: function onOk() {
          var rowMark = _this3.comModelProps.rowMark.toLowerCase();
          _this3.deleteGridData(row[rowMark]);
        }
      });
    },
    rowModifyOper: function rowModifyOper(row, index, operMark) {
      var oper = this.getRowOperByMark(operMark);
      if (oper.url) {
        var url = this.template(oper.url, { row: row, user: this.$store.getters.sessionUser, req: this.$route.query });
        this.windowOpen(url, oper);
      } else {
        alert('未配置修改地址');
      }
    },
    rowDetailOper: function rowDetailOper(row, index, operMark) {
      var oper = this.getRowOperByMark(operMark);
      if (oper.url) {
        var url = this.template(oper.url, { row: row, user: this.$store.getters.sessionUser, req: this.$route.query });
        this.windowOpen(url, oper);
      } else {
        alert('未配详情地址');
      }
    },
    rowDealFunction: function rowDealFunction(row, index, operMark) {
      // 行操作
      var oper = this.getRowOperByMark(operMark);
      if (oper.dealFunction) {
        var dealFunc = 'return ' + oper.dealFunction;
        var func = new Function(dealFunc)();
        func(row, this);
      } else {
        alert('未配置自定义函数');
      }
    },
    getHeadOperByMark: function getHeadOperByMark(operMark) {
      var headOper = [];
      headOper = headOper.concat(this.headOper, this.headOperBatch);
      var oper = void 0;
      for (var i = 0, len = headOper.length; i < len; i++) {
        if (headOper[i].mark === operMark) {
          oper = headOper[i];
          break;
        }
      }
      return oper;
    },
    getRowOperByMark: function getRowOperByMark(operMark) {
      var rowOper = [];
      rowOper = rowOper.concat(this.rowOper, this.rowOperBatch);
      var oper = void 0;
      for (var i = 0, len = rowOper.length; i < len; i++) {
        if (rowOper[i].mark === operMark) {
          oper = rowOper[i];
          break;
        }
      }
      return oper;
    },
    windowOpen: function windowOpen(url, oper) {
      // 替换URL变量
      // 遮罩对话框
      if (oper.openMode === '0') {
        var width = oper.pageWidth;
        var height = oper.pageHeight;
        if (width && Number(width) >= 0) {
          this.modalWidth = width;
        }
        if (height && Number(height) >= 0) {
          this.modalHeight = height;
        }
        this.modalTitle = oper.title;
        this.iframeUrl = url;
        this.modalId = oper.mark;
        this.iframeComponent = 'iframeComponent';
        this.modalStatus = true;
      } else if (oper.openMode === '1') {
        window.open(url);
      } else if (oper.openMode === '2') {
        window.location.href = url;
      }
    },
    closeModal: function closeModal() {
      this.modalStatus = false;
      this.iframeComponent = null;
      this.iframeUrl = '';
    },
    closeExportOptModal: function closeExportOptModal() {
      this.gridExportOptStatus = false;
    },
    batchDelete: function batchDelete() {
      var idArr = [];
      var rowMark = this.comModelProps.rowMark.toLowerCase();
      this.batch_select.forEach(function (item) {
        idArr.push(item[rowMark]);
      });
      this.deleteGridData(idArr.join(','));
    },
    deleteGridData: function deleteGridData(ids) {
      var _this4 = this;

      this.$store.dispatch('postRequest', { url: this.$path.com_model_datagrid_delete, params: { mark: this.comModel.mark, ids: ids } }).then(function (resp) {
        if (resp.success) {
          _this4.$Modal.remove();
          _this4.query_grid_data();
          setTimeout(function () {
            _this4.$Modal.success({
              title: '成功提示',
              content: '删除数据成功'
            });
          }, 500);
        } else {
          _this4.$Modal.remove();
          setTimeout(function () {
            _this4.$Modal.error({
              title: '温馨提示',
              content: resp.msg
            });
          }, 500);
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/table-grid/mixins/oper.js
// module id = 30
// module chunks = 0